export const formBuilder = () => {
  return {
    publish: 'Publish',
    type: 'Type',
    service: 'Service',
    trade: 'Trade',
    publish_form: 'Publish Form!',
    publish_form_message_0: 'You are about to publish a field form which will be displayed for all field users when a work order with ',
    publish_form_message_1: 'and',
    publish_form_message_2: 'is created.',
    delete_element: 'Delete Element',
    delete_element_message:
      'You are about to delete this element from the page.  Would you like to continue?',
    yes: 'Yes',
    ok: 'Ok',
    deactivate_field_form_title: 'Deactivate Field Form',
    deactivate_form_main_message_0: 'Deactivating this published form will restrict users from accessing it and the system will revert back to the default form for this trade, type, and service combination.',
    deactivate_form_main_message_1: 'Note: Editing and re-publishing this form will ensure users can access it for all in-progress and open work orders.',
    deactivate_form_extra_message:
      'Would you like to deactivate this field form?',
    section_title: 'Section Title',
    element: 'element',
    element_plural: 'elements',
    no_elements: 'No Elements',
    page_one: 'Page 1',
    section_one: 'Section 1',
    duplicate_wo: 'Duplicate WO Assignment',
    duplicate_wo_title: 'Errors Found!',
    duplicate_wo_message_0:
      'There is already a published field form with the work order attributes of Trade - ',
    duplicate_wo_message_1: ' Type - ',
    duplicate_wo_message_2: ', and Service - ',
    duplicate_wo_message_3:
      '.  Either deactivate the existing form or reassign this form to continue.',
    duplicate_form_name_message_0: 'There is already a published field form with the form name ',
    duplicate_form_name_message_1: '.  Either deactivate the existing form or update the form name to continue.',
    unsaved_changes: 'Unsaved Changes',
    unsaved_changes_message:
      'You have unsaved changes. Would you like to save those changes?',
    save: 'Save',
    discard: 'Discard',
    preview: 'Preview',
    draft: 'Draft',
    clone: 'Clone',
    delete: 'Delete',
    cancel: 'Cancel',
    center_panel: {
      deactivate: 'Deactivate',
      publish: 'Publish',
      lets_build: 'Let’s build an amazing form!',
      empty_message:
        'Build your form structure using pages and sections then add all the form elements you want by clicking “+” or dragging them into the space below. You’ll find many available options on the left panel, under Elements tab.',
      published_mode: 'Published Mode',
      draft_mode: 'Draft Mode',
      empty_search_message:
        'Whoops..  There are no elements that match your search.  Check your search criteria and try again.'
    },
    audit_trail_status: {
      active: 'Published',
      deleted: 'Deleted',
      draft: 'Draft',
      cloned: 'Cloned',
      saved: 'Saved',
      deactivated: 'Deactivated'
    },
    left_panel: {
      structure_tab_message_0: 'Create additional sections by selecting “+” to section off your elements.',
      structure_tab_message_1: 'Creating additional pages is coming soon.',
      audit: 'Audit Trail',
      structure: 'Structure',
      elements: 'Elements',
      details: 'Details',
      description: 'Description',
      pages: 'Pages',
      select_drop_message:
        'Select and “+” or drag and drop elements into your page to build your amazing form.',
      audit_trail: 'Audit Trail',
      sections: 'Sections',

      remove_section_title: 'Remove Section',
      remove_section_message:
        'Are you sure you want to remove section {{sectionTitle}}',
      accept: 'Accept',
      cancel: 'Cancel'
    },
    right_panel: {
      enable: 'Enable',
      disable: 'Disable',
      required: 'Required',
      mandatory: 'Mandatory',
      optional: 'Optional',
      add_element: 'Add an element to your form',
      fields_reorder: 'Fields can be reordered by dragging them',
      continue_message_title: 'Select an element to customize its content.',
      continue_message_text:
        'Continue adding elements and customizing the content to build out your desired field form.'
    },
    dragged_element: {
      helpful_hint: 'Helpful hint',
      time_stamp: 'Time stamp',
      required_field: 'Required field',
      logic: 'Logic'
    },
    elements: {
      product_name: 'Product name',
      product_type: 'Product type',
      product_description: 'Product description',
      price_each: 'Price each',
      total_each: 'Total each',
      hidden: 'Hidden',
      view_only: 'View only',
      editable: 'Editable',
      product_creation: 'Product creation',
      authorization_field_title: 'Authorization - Review, Sign, & Authorize',
      authorization_field_subtitle: 'Authorization - Review Form, Signature, and Authorize Work',
      authorization_field_message_one: 'Authorization Field will generate a beautiful in-app preview of all completed elements within the form for your client to review, sign, and authorize.',
      authorization_field_message_two: 'This will be the last element listed in the field form.',
      due_on_receipt: 'Due on receipt',
      net_7: 'Net 7',
      net_15: 'Net 15',
      net_30: 'Net 30',
      net_45: 'Net 45',
      authorization_to_proceed: 'Authorization To Proceed',
      payment_terms: 'Payment Terms',
      due_date: 'Due Date',
      signature_required: 'Signature Required',
      signature_and_name_required: 'Signature and Name Required',
      authorization_field: 'Authorization Field',
      labor_type: 'Labor Type',
      if_one_material_is_populated: 'If one material is populated',
      if_more_than_one_material_is_populated: 'If more than one material is populated',
      enable: 'Enable',
      description: 'Description',
      rate: 'Rate',
      one_line_item: 'one line item',
      enable_selections_based_on_salesforce: 'Enable - Selections Based on Salesforce',
      enable_custom_options: 'Enable - Custom Options',
      disable: 'Disable',
      line_item: 'Line Item',
      labor_description: 'Labor Description',
      tax: 'Tax',
      total_amount_due: 'Total Amount Due',
      line_items_message_one: 'Line Items enable the Technician to add what costs are incurred to a WO. Each Line Item has a product/service, amount, quantity, tax rate and total amount.',
      line_items_message_two: 'This information can be used to help generate Invoices.',
      line_items_message_three: 'Ensure your inventory is connected prior to enabling inventory',
      line_items: 'Line Items Field',
      products_services: 'Products/Services',
      service_checklist: 'Service Checklist',
      items: 'Items',
      item_price: 'Item Pricing',
      enable_item_price_tax_total_price: 'Enable item price, tax & total price fields',
      disable_item_price_tax_total_price: 'Disable item price, tax & total price fields',
      if_one_line_item_is_populated: 'If one line item is populated',
      if_more_than_one_line_item_is_populated: 'If more than one line item is populated',
      line_items_descriptions_quantities_pricing: 'Line Items - Rates, Descriptions, Quantities, & Amounts',
      material_parts: 'Material / Parts List',
      equipment_inventory: 'Equipment Inventory',
      enter_value: 'Enter Value',
      text_description: 'Text Description',
      dropdown_selection: 'Drop Down Selection',
      selection_type: 'Selection Type',
      single_selection: 'Single selection',
      multiple_selections: 'Multiple selections',
      helpful_hint_title:
        'Helpful Hint (icon is displayed when text is entered)',
      helpful_hint_placeholder: 'Enter helpful hint description',
      title_title: 'Title / Item description',
      time_stamp_title: 'Time stamp',
      title_placeholder: 'Enter title / item description (00 character length)',
      buttons_generator: '# of buttons',
      button_label_a: 'Button',
      button_label_b: 'tittle',
      created_button_placeholder: 'Enter title (less than 25 characters)',
      required_field_title: 'Required field',
      selection_title: 'Selection / option',
      empty_state_message_title: 'Empty state message',
      text_input_placeholder: 'Enter title / item description',
      empty_state_message_placeholder: 'Enter empty state message',
      input_field_type_title: 'Input Field Type',
      alpha_numeric: 'Alpha / Numeric',
      alpha_only: 'Alpha only',
      numeric_only: 'Numeric only',
      dollar_value: 'Dollar value ($)',
      percentage_value: 'Percentage value (%)',
      date_time: 'Date',
      nested_logic: 'Nested Logic',
      logical_action: 'Logical Action',
      if_text_is_populated: 'If text is populated',
      then_perform: 'Then Perform',
      selection_button: 'Add Selection',
      selection: 'Selection',
      selection_input_placeholder:
        'Enter the selection / item description (00 character length)',
      allow_multiple_selections: 'Allow multiple selections',
      number_of_selections: '# of selections',
      yes: 'Yes',
      no: 'No',
      mandatory: 'Mandatory',
      optional: 'Optional',
      check_box: 'Check Box',
      none: 'None',
      dropdown_selection_option: 'If selection {{option}} is selected',
      then_perform_placeholder: 'Add element to nested logic section',
      enter_title_placeholder: 'Enter Title / Description',
      checklist_item: 'Checklist Item',
      selection_option: 'Selection / option',
      on_off: 'On / Off',
      yes_no: 'Yes / No',
      toggle: 'Toggle',
      if_check_mark_is_selected: "If 'check mark' is selected then",
      if_red_x_is_selected: "'If red 'X' is selected then",
      photos: 'Photos',
      number_of_photos: '# of Photos',
      photo_title: 'Title / description',
      location: 'Location (GPS)',
      attributes: 'Attributes',
      photo_number: 'Photo {{number}}',
      take_photo_or_upload_from_gallery: 'Take Photo &/or Upload From Gallery',
      take_photo_only: 'Take Photo (Only)',
      upload_photo_from_gallery_only: 'Upload Photo From Gallery (Only)',
      multi_button_selection: 'Multi-Button Selection',
      number_of_buttons: '# of buttons',
      button_number_title: 'Button {{number}} title',
      button_placeholder: 'Enter title (less than 25 characters)',
      button_selection_option: 'If button {{option}} is selected',
      signature: 'Signature',
      entered_name_required: 'Entered name required',
      entered_name_optional: 'Entered name optional',
      coming_soon: 'Coming soon',
      alpha_numeric_special_characters: 'Alpha / Numeric / Special Characters',
      attachments: 'Attachments',
      number_of_attachments: '# of Attachments',
      all_document_formats: 'All document formats',
      pdf_only: 'PDF only',
      jpeg_and_png_only: 'JPEG and PNG only',
      csv_spreadsheet_only: 'CSV | Spreadsheet only',
      docx_only: 'DOCX | Word Document only',
      attachment_title: 'Title / description',
      attachment_number: 'Attachment {{number}}'
    },
    top_bar: {
      draft: 'Draft',
      published: 'Published',
      inactive: 'Inactive'
    }
  }
}
